import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { VistaBloquesType } from 'enums/vistaBloques';

const initialState: string = VistaBloquesType.guiaDigital;

const vistaBloquesStateSlice = createSlice({
	name: 'vistaBloquesState',
	initialState,
	reducers: {
		setVistaBloques: (state, action: PayloadAction<VistaBloquesType>) => {
			return action.payload;
		}
	}
});

export const { setVistaBloques } = vistaBloquesStateSlice.actions;

export default vistaBloquesStateSlice.reducer;
